var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['scrollable-tabs', ( _obj = {}, _obj[("tab-overflow-" + _vm.$_scrollableDirectionX)] = _vm.$_scrollableDirectionX, _obj )]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }